import {Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Info} from "@mui/icons-material";

export default function () {
    return (
        <Paper elevation={3}>
            <Box display="flex" alignItems={"center"} px={2} py={1}>
                <Box display="flex" alignItems={"center"}>
                    <Info color={"warning"}/>
                </Box>
                <Box ml={1}>
                    <Typography display={"block"}>
                        Le sociétaire à reçu un SMS pour signer éléctroniquement votre devis.
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
}
